module.exports = __webpack_public_path__ + "img/frailty.f1bf88c1.svg";